import React, { ReactElement } from "react";

type HelpBoxProps = {
    name:string;
    info:string;
}

const formatInfo = (info:string) : ReactElement => {
    const lines:Array<string> = info.split("\n");
    return <div>
        {lines.map((line:string) => {
            if (line.startsWith("> "))
                return <li style={{marginBottom:".2vh"}}>{line.substring(2)}</li>;
            return line + " ";
        })}
    </div>;
}

export const HelpBox = (props:HelpBoxProps):ReactElement => {
    const [open, setOpen] = React.useState<boolean>(false);
    if (open) 
        return <div className="ModalDialogBackground" onClick={()=>setOpen(false)}>
            <div className="HelpBoxOpen" ><h3>{props.name}</h3><hr/>{formatInfo(props.info)}<div className="Hint">Click anywhere to close this window</div></div>
            </div>
    return <div className="HelpBoxClosed" onClick={()=>setOpen(true)}>?</div>;
}

